import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { memo } from "react";
import BaseNavbar from "../base";

export default memo(() => {
  const buttonStyles = makeStyles({
    root: {
      fontWeight: "700",
      textTransform: "uppercase",
      backgroundColor: "#E1E3EC !important",
      "&:hover": {
        backgroundColor: "#C8CAD3 !important",
      },
    },
    label: {
      color: "#000",
      fontFamily: "Inter, sans-serif",
      fontWeight: "bolder",
      fontSize: "13px !important",
    },
  });

  return (
    <BaseNavbar>
      <div style={{ flexGrow: 1 }}></div>

      <div className="nb-out-block">
        <span className="hidden-mobile hidden-xs">Precisa de uma conta?</span>

        <Button
          size="large"
          classes={buttonStyles()}
          onClick={() =>
            window.open("https://mercatorio.com.br/contato/", "_blank")
          }
        >
          ENTRE EM CONTATO
        </Button>
      </div>
    </BaseNavbar>
  );
});
